import { createSlice, createEntityAdapter } from '@reduxjs/toolkit';
import { toast } from 'react-hot-toast';

const productsInBasketAdapter = createEntityAdapter({
  selectId: (product) => product._id,
});

const initialState = {
  ui: {
    loading: false,
    loading_basket: false,
    loading_products_in_basket: false,
    loading_coupon: false,
    adding_product: false,
    deleting_product: false,
    stats: {
      pageCount: 1,
    },
  },
  basket_details: {},
  coupon: {},
  products: [],
  basket: productsInBasketAdapter.getInitialState(),
  user_basket: [],
  user_products: [],
  partner_config: [],
  delivery_locations: [],
  customer_basket: {},
  loggedInCart: [],
};

export const basketReducerSlice = createSlice({
  name: 'basket',
  initialState,
  reducers: {
    update_basket_quantity: (state) => {
      state.ui.loading_products_in_basket = true;
    },
    update_basket_quantity_success: (state, { payload }) => {
      state.ui.loading_products_in_basket = false;
      const result = state.user_products.map((data) =>
        data._id === payload._id ? { ...data, ...payload } : data,
      );
      state.user_products = result;
      const prev = JSON.parse(localStorage.getItem('loggedInCart')) || {};
      const partner = localStorage.getItem('partner_id');
      const cartItems = prev[partner];

      const findProductIndex = cartItems.findIndex(
        (item) => item._id === payload._id,
      );

      if (findProductIndex !== -1) {
        cartItems[findProductIndex].quantity = payload.quantity;
        cartItems[findProductIndex].price.value = payload.price.value;
      }
      let doc = {
        ...prev,
        [partner]: cartItems,
      };
      localStorage.setItem('loggedInCart', JSON.stringify(doc));
      state.loggedInCart = doc[partner];
    },
    update_basket_quantity_error: (state) => {
      state.ui.loading_products_in_basket = false;
    },

    apply_coupon_success: (state, { payload }) => {
      state.coupon = payload;
      state.ui.loading_coupon = false;
    },
    apply_coupon_error: (state) => {
      state.ui.loading_coupon = false;
    },
    apply_coupon: (state) => {
      state.ui.loading_coupon = true;
    },

    get_products_success: (state, { payload }) => {
      state.ui.loading = false;
      const { products, stats } = payload;
      state.products = products;
      state.ui.stats = {
        ...stats,
      };
    },
    get_products_error: (state) => {
      state.ui.loading = false;
    },
    get_basket_success: (state, { payload }) => {
      state.basket_details = payload;
      state.ui.loading_basket = false;
    },
    get_basket_error: (state) => {
      state.ui.loading_basket = false;
    },
    initialize_basket: (state) => {
      state.ui.loading = true;
      state.ui.loading_basket = true;
      state.ui.loading_products_in_basket = true;
    },
    get_basket_products: (state) => {
      state.ui.loading_products_in_basket = true;
    },
    get_basket_products_success: (state, { payload }) => {
      productsInBasketAdapter.setAll(state.basket, payload.products);
      state.ui.loading_products_in_basket = false;
    },
    get_baset_products_error: (state) => {
      state.ui.loading_products_in_basket = false;
    },
    add_product_to_basket: (state) => {
      state.ui.adding_product = true;
    },
    add_product_to_basket_error: (state) => {
      state.ui.adding_product = false;
    },
    add_product_to_basket_success: (state, { payload }) => {
      productsInBasketAdapter.upsertOne(state.basket, payload);
      state.ui.adding_product = false;
    },
    delete_product_from_basket_success: (state, { payload }) => {
      state.ui.deleting_product = false;
      const response = state.user_products.filter(
        (data) => data._id !== payload._id,
      );
      state.user_products = response;
      const prev = JSON.parse(localStorage.getItem('loggedInCart')) || [];
      const partner = localStorage.getItem('partner_id');
      const cartItems = prev[partner];

      if (cartItems.length > 0) {
        const existingProduct = cartItems.findIndex(
          (item) => item._id === payload._id,
        );

        if (existingProduct !== -1) {
          cartItems.splice(existingProduct, 1);
        }

        let doc = {
          ...prev,
          [partner]: cartItems,
        };
        localStorage.setItem('loggedInCart', JSON.stringify(doc));
        state.loggedInCart = doc[partner];
      }
    },
    delete_product_from_basket: (state) => {
      state.ui.deleting_product = true;
    },
    delete_product_from_basket_error: (state) => {
      state.ui.deleting_product = false;
    },
    get_user_basket: (state) => {
      state.loading = true;
    },
    get_user_basket_success: (state, { payload }) => {
      state.loading = false;
      const { baskets } = payload;
      state.user_basket = baskets;
    },
    get_user_basket_error: (state) => {
      state.loading = false;
    },
    get_user_products: (state) => {
      state.ui.loading = true;
    },
    get_user_products_success: (state, { payload }) => {
      state.ui.loading = false;
      state.user_products = payload.products;
    },
    get_user_products_error: (state) => {
      state.ui.loading = false;
    },
    get_partner_config: (state) => {
      state.ui.loading = true;
    },
    get_partner_config_success: (state, { payload }) => {
      state.ui.loading = false;
      state.partner_config = payload;
    },
    get_partner_config_error: (state) => {
      state.ui.loading = false;
    },
    get_delivery_location: (state) => {
      state.ui.loading = true;
    },
    get_delivery_location_success: (state, { payload }) => {
      state.ui.loading = false;
      const { locations } = payload;
      state.delivery_locations = locations;
    },
    get_delivery_location_error: (state) => {
      state.ui.loading = false;
    },
    get_customer_basket: (state) => {
      state.ui.loaading = true;
    },
    get_customer_basket_success: (state, { payload }) => {
      state.ui.loading = false;
      state.customer_basket = payload;
    },
    get_customer_basket_error: (state) => {
      state.ui.loading = false;
    },
    get_logged_in_cart: (state, { payload }) => {
      const basketItems = JSON.parse(localStorage.getItem('loggedInCart')) || [];
      if (payload) {
        state.loggedInCart = basketItems[payload];
      }
    },
    add_product: (state) => {
      state.ui.adding_product = true;
    },
    add_product_success: (state, { payload }) => {
      const { products } = payload;
      const basketItems = JSON.parse(localStorage.getItem('loggedInCart')) || [];
      const partner = localStorage.getItem('partner_id');
      const cartItems = basketItems[partner] || [];

      products.forEach((product) => {
        const existingProduct = cartItems.findIndex(
          (item) => item._id === product._id && item.size === product.size,
        );

        if (existingProduct !== -1) {
          cartItems[existingProduct].quantity = product.quantity;
          toast.success(`${cartItems[existingProduct]?.product?.name} updated!!`);
        } else {
          cartItems.push(product);
          toast.success(`${product.product?.name} added to basket!!`);
        }
      });

      const doc = {
        ...basketItems,
        [partner]: cartItems,
      };
      localStorage.setItem('loggedInCart', JSON.stringify(doc));
      state.loggedInCart = doc[partner];
      state.ui.adding_product = false;
    },
    add_product_error: (state) => {
      state.ui.adding_product = false;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  get_products_error,
  get_products_success,
  get_basket_success,
  get_basket_error,
  initialize_basket,
  get_baset_products_error,
  get_basket_products_success,
  get_basket_products,
  add_product_to_basket,
  add_product_to_basket_error,
  add_product_to_basket_success,
  delete_product_from_basket,
  delete_product_from_basket_error,
  delete_product_from_basket_success,
  update_basket_quantity,
  update_basket_quantity_success,
  update_basket_quantity_error,
  apply_coupon,
  apply_coupon_error,
  apply_coupon_success,
  get_user_basket,
  get_user_basket_success,
  get_user_basket_error,
  get_user_products,
  get_user_products_success,
  get_user_products_error,
  get_partner_config,
  get_partner_config_success,
  get_partner_config_error,
  get_delivery_location,
  get_delivery_location_success,
  get_delivery_location_error,
  get_customer_basket,
  get_customer_basket_success,
  get_customer_basket_error,
  add_product,
  add_product_success,
  add_product_error,
  get_logged_in_cart,
} = basketReducerSlice.actions;

export const productsInBasketSelector = productsInBasketAdapter.getSelectors();

export default basketReducerSlice.reducer;
